import { FaArrowRight } from "react-icons/fa6";
import { Link } from "react-router-dom";

const ProductCard = ({ product }) => {
  const {
    _id,
    Product_name,
    Product_Details_Photo,
    Pack_Size,
    brand_Name,
    Net_Wt,
    Gross_Wt,
    Carton_Dim,
  } = product;

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="card w-full card-compact bg-base-100 shadow-xl">
      <figure className="overflow-hidden">
        <img
          className="w-fit h-60 object-cover hover:scale-105 transition-transform duration-500"
          src={Product_Details_Photo}
          loading="lazy"
          alt="Product"
        />
      </figure>
      <div className="card-body p-0 lg:p-4">
        <div className="flex justify-between ">
          <h2 className="text-sm lg:text-base font-semibold text-left">
            {Product_name}
          </h2>
        </div>
        <div>
          <div className="flex justify-between lg:py-1">
            <p className="text-gray-500 text-xs lg:text-sm text-left ">
              Brand :
            </p>
            <p className="text-gray-500 text-xs lg:text-sm font-semibold text-right">
              {product.brand_Name?.replace(/_/g, " ")}
            </p>
          </div>
          <div className="flex justify-between lg:py-1">
            <p className="text-gray-500 text-xs lg:text-sm text-left ">
              Net Weight :
            </p>
            <p className="text-gray-500 text-xs lg:text-sm font-semibold text-right">
              {Net_Wt} kg
            </p>
          </div>
          <div className="flex justify-between lg:py-1">
            <p className="text-gray-500 text-xs lg:text-sm text-left ">
              Pack Size :
            </p>
            <p className="text-gray-500 text-xs lg:text-sm font-semibold text-right">
              {Pack_Size}
            </p>
          </div>
          <div className="flex justify-between lg:py-1">
            <p className="text-gray-500 text-xs lg:text-sm text-left ">
              Gross Weight :
            </p>
            <p className="text-gray-500 text-xs lg:text-sm font-semibold text-right">
              {Gross_Wt} kg
            </p>
          </div>
          <div className="flex flex-wrap justify-between lg:py-1">
            <p className="text-gray-500 text-xs lg:text-sm text-left ">
              Carton Dimension(Approx) :
            </p>
            <p className="text-gray-500 text-xs lg:text-sm font-semibold text-right">
              {Carton_Dim}
            </p>
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center pb-4">
        <Link to={`/productDetails/${_id}`}>
          <button
            onClick={scrollToTop}
            className="btn flex items-center justify-center gap-2 lg:px-16 bg-[#1C3A27] font-bold text-white hover:bg-[#1DA14D]"
          >
            view Details <FaArrowRight />
          </button>
        </Link>
      </div>
    </div>
  );
};
export default ProductCard;
